import { Fragment, useEffect, useState } from "react";
import { Dialog, Disclosure, Menu, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import {
  ChevronDownIcon,
  FunnelIcon,
  MinusIcon,
  PlusIcon,
  Squares2X2Icon,
} from "@heroicons/react/20/solid";
import Navbar from "./Navbar";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCategoriesAsync,
  fetchColorsAsync,
  fetchProductsAsync,
  fetchSizesAsync,
  selectCategories,
  selectColors,
  selectSizes,
} from "../features/product/productSlice";
import {
  selectFilter,
  selectSort,
  setFilterSync,
  setSortSync,
} from "../features/common/commonSlice";

const sortOptions = [
  { name: "Best Rating", order: "desc", sort: "rating", current: false },
  { name: "Newest", order: "desc", sort: "createdAt", current: false },
  {
    name: "Price: Low to High",
    order: "asc",
    sort: "discountPrice",
    current: false,
  },
  {
    name: "Price: High to Low",
    order: "desc",
    sort: "discountPrice",
    current: false,
  },
];
const subCategories = [
  { name: "Footwear", id: "category" },

  { name: "Nike Plus", id: "category" },
  { name: "Jordan Brand", id: "category" },
  { name: "Sports Bras", id: "category" },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function CategoryFilter({ children }) {
  const dispatch = useDispatch();
  const sizes = useSelector(selectSizes);
  const colors = useSelector(selectColors);
  const filterLink = useSelector(selectFilter);
  const sortLink = useSelector(selectSort);
  const categories = useSelector(selectCategories);
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);
  const [filterSet, setFilterSet] = useState({});
  const [optionValues, setOptionValues] = useState([]);
  const [sort, setSort] = useState({});
  function convertToNewLabelValueFormat(inputArray) {
    const newArray = inputArray.map((item) => {
      return {
        label: item.name,
        value: item.name,
      };
    });

    return newArray;
  }
  const modifiedColors = convertToNewLabelValueFormat(colors);

  const filters = [
    {
      id: "gender",
      name: "Gender",
      options: [
        { label: "Men", value: "Men" },
        { label: "Women", value: "Women" },
        { label: "Unisex", value: "Unisex" },
      ],
    },
    {
      id: "kids",
      name: "Kids",
      options: [
        { label: "Boys", value: "Boys" },
        { label: "Girls", value: "Girls" },
      ],
    },
    {
      id: "color",
      name: "Color",
      options: modifiedColors,
    },
    {
      id: "category",
      name: "Category",
      options: categories,
    },
    {
      id: "size",
      name: "Size",
      options: sizes,
    },
  ];
  const handleFilter = (e, section, option) => {
    const newFilter = { ...filterSet };
    if (e.target.checked) {
      if (newFilter[section.id]) {
        newFilter[section.id].push(option.value);
      } else {
        newFilter[section.id] = [option.value];
      }
      setOptionValues([...optionValues, option.value]);
    } else {
      const index = newFilter[section.id].findIndex(
        (el) => el === option.value
      );
      newFilter[section.id].splice(index, 1);
      let data = [...optionValues];
      const index2 = data.findIndex((el) => el === option.value);
      data.splice(index2, 1);
      setOptionValues(data);
    }
    setFilterSet(newFilter);
  };

  const handleSort = (e, option) => {
    const sort = { _sort: option.sort, _order: option.order };
    setSort(sort);
  };

  const handleSubCategories = (category) => {
    console.log(category);
    const newFilter = { ...filterSet };

    newFilter[category.id] = [category.name];

    setOptionValues([category.name]);
    setFilterSet(newFilter);
    setMobileFiltersOpen(false);
  };

  useEffect(() => {
    if (
      Object.keys(filterLink).length > 0 ||
      Object.keys(sortLink).length > 0
    ) {
      const tempFilter = filterLink;
      const tempSort = sortLink;
      dispatch(setFilterSync({}));
      dispatch(setSortSync({}));
      setTimeout(() => {
        dispatch(fetchProductsAsync({ filterSet: tempFilter, sort: tempSort }));
      }, 500);
    } else {
      dispatch(fetchProductsAsync({ filterSet, sort }));
    }
  }, [dispatch, filterSet, sort, filterLink, sortLink]);
  return (
    <>
      <Navbar></Navbar>
      <div className="bg-white px-5 md:px-12 ">
        <div>
          {/* Mobile filter dialog */}
          <Transition.Root show={mobileFiltersOpen} as={Fragment}>
            <Dialog
              as="div"
              className="relative z-40 lg:hidden"
              onClose={setMobileFiltersOpen}
            >
              <Transition.Child
                as={Fragment}
                enter="transition-opacity ease-linear duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity ease-linear duration-300"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-black bg-opacity-25" />
              </Transition.Child>

              <div className="fixed inset-0 z-40 flex">
                <Transition.Child
                  as={Fragment}
                  enter="transition ease-in-out duration-300 transform"
                  enterFrom="translate-x-full"
                  enterTo="translate-x-0"
                  leave="transition ease-in-out duration-300 transform"
                  leaveFrom="translate-x-0"
                  leaveTo="translate-x-full"
                >
                  <Dialog.Panel className="relative ml-auto flex h-full w-full max-w-xs flex-col overflow-y-auto bg-white py-4 pb-2 shadow-xl">
                    <div className="flex items-center justify-between px-4">
                      <h2 className="text-lg font-medium text-gray-900">
                        Filters
                      </h2>
                      <button
                        type="button"
                        className="flex h-10 w-10 items-center justify-center rounded-md bg-white p-2 text-gray-400"
                        onClick={() => setMobileFiltersOpen(false)}
                      >
                        <span className="sr-only">Close menu</span>
                        <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                      </button>
                    </div>

                    {/* Filters */}
                    <form className="mt-4 border-t border-gray-200">
                      <h3 className="sr-only">Categories</h3>
                      <ul
                        role="list"
                        className="px-2 py-3 font-medium text-gray-900"
                      >
                        {subCategories.map((category) => (
                          <li
                            key={category.name}
                            onClick={() => handleSubCategories(category)}
                          >
                            <a href={category.href} className="block px-2 py-3">
                              {category.name}
                            </a>
                          </li>
                        ))}
                      </ul>

                      {filters.map((section) => (
                        <Disclosure
                          as="div"
                          key={section.id}
                          className="border-t border-gray-200 px-4 py-6"
                        >
                          {({ open }) => (
                            <>
                              <h3 className="-mx-2 -my-3 flow-root">
                                <Disclosure.Button className="flex w-full items-center justify-between bg-white px-2 py-3 text-gray-400 hover:text-gray-500">
                                  <span className="font-medium text-gray-900">
                                    {section.name}
                                  </span>
                                  <span className="ml-6 flex items-center">
                                    {open ? (
                                      <MinusIcon
                                        className="h-5 w-5"
                                        aria-hidden="true"
                                      />
                                    ) : (
                                      <PlusIcon
                                        className="h-5 w-5"
                                        aria-hidden="true"
                                      />
                                    )}
                                  </span>
                                </Disclosure.Button>
                              </h3>
                              <Disclosure.Panel className="pt-6">
                                <div className="space-y-6">
                                  {section.options.map((option, optionIdx) => (
                                    <div
                                      key={option.value}
                                      className="flex items-center"
                                    >
                                      <input
                                        id={`filter-mobile-${section.id}-${optionIdx}`}
                                        name={`${section.id}[]`}
                                        defaultValue={option.value}
                                        onClick={(e) =>
                                          handleFilter(e, section, option)
                                        }
                                        type="checkbox"
                                        checked={optionValues.includes(
                                          option.value
                                        )}
                                        className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                      />
                                      <label
                                        htmlFor={`filter-mobile-${section.id}-${optionIdx}`}
                                        className="ml-3 min-w-0 flex-1 text-gray-500"
                                      >
                                        {option.label}
                                      </label>
                                    </div>
                                  ))}
                                </div>
                              </Disclosure.Panel>
                            </>
                          )}
                        </Disclosure>
                      ))}
                    </form>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </Dialog>
          </Transition.Root>

          {/* <main className="mx-0 max-w-full px-4 sm:px-6 lg:px-4 lg:max-w-screen-xl"> */}
          <main className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-4 lg:max-w-full">
            <div className="flex items-baseline justify-between border-b border-gray-200  ">
              <h1 className="text-lg">Gear Up</h1>
              <div className="flex items-center">
                <Menu as="div" className="relative inline-block text-left">
                  <div>
                    <Menu.Button className="group inline-flex justify-center text-sm px-4 font-medium text-gray-700 hover:text-gray-900">
                      Sort
                      <ChevronDownIcon
                        className="-mr-1 ml-1 h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500"
                        aria-hidden="true"
                      />
                    </Menu.Button>
                  </div>

                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className="absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md bg-white shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <div className="py-1">
                        {sortOptions.map((option) => (
                          <Menu.Item key={option.name}>
                            {({ active }) => (
                              <p
                                onClick={(e) => handleSort(e, option)}
                                className={classNames(
                                  option.current
                                    ? "font-medium text-gray-900"
                                    : "text-gray-500",
                                  active ? "bg-gray-100" : "",
                                  "block px-4 py-2 text-sm cursor-pointer"
                                )}
                              >
                                {option.name}
                              </p>
                            )}
                          </Menu.Item>
                        ))}
                      </div>
                    </Menu.Items>
                  </Transition>
                </Menu>

                <button
                  type="button"
                  className="-m-2 p-2 text-gray-400 hover:text-gray-500 lg:hidden"
                  onClick={() => setMobileFiltersOpen(true)}
                >
                  <span className="sr-only">Filters</span>
                  <FunnelIcon className="h-5 w-5" aria-hidden="true" />
                </button>
              </div>
            </div>

            <section aria-labelledby="products-heading" className="pb-2 pt-6 ">
              <h2 id="products-heading" className="sr-only">
                Products
              </h2>
              <div className="grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-4">
                {/* Filters */}
                <div className="md:overflow-auto lg:h-[71vh]">
                  <form className="hidden lg:block ">
                    <h3 className="sr-only">Categories</h3>
                    <ul
                      role="list"
                      className="space-y-4 border-b border-gray-200 pb-6 text-sm font-medium text-gray-900"
                    >
                      {subCategories.map((category) => (
                        <li
                          key={category.name}
                          onClick={() => handleSubCategories(category)}
                        >
                          <a href={category.href}>{category.name}</a>
                        </li>
                      ))}
                    </ul>

                    {filters.map((section) => (
                      <Disclosure
                        as="div"
                        key={section.id}
                        className="border-b border-gray-200 py-6 px-3"
                      >
                        {({ open }) => (
                          <>
                            <h3 className="-my-3 flow-root ">
                              <Disclosure.Button className="flex w-full items-center justify-between bg-white py-3 text-sm text-gray-400 hover:text-gray-500">
                                <span className="font-medium  text-gray-900">
                                  {section.name}
                                </span>
                                <span className="ml-6 flex items-center">
                                  {open ? (
                                    <MinusIcon
                                      className="h-5 w-5"
                                      aria-hidden="true"
                                    />
                                  ) : (
                                    <PlusIcon
                                      className="h-5 w-5"
                                      aria-hidden="true"
                                    />
                                  )}
                                </span>
                              </Disclosure.Button>
                            </h3>
                            <Disclosure.Panel className="pt-6">
                              <div className="space-y-4">
                                {section.options.map((option, optionIdx) => (
                                  <div
                                    key={option.value}
                                    className="flex items-center"
                                  >
                                    <input
                                      id={`filter-${section.id}-${optionIdx}`}
                                      name={`${section.id}[]`}
                                      defaultValue={option.value}
                                      onClick={(e) =>
                                        handleFilter(e, section, option)
                                      }
                                      type="checkbox"
                                      checked={optionValues.includes(
                                        option.value
                                      )}
                                      className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                    />
                                    <label
                                      htmlFor={`filter-${section.id}-${optionIdx}`}
                                      className="ml-3 text-sm text-gray-600"
                                    >
                                      {option.label}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            </Disclosure.Panel>
                          </>
                        )}
                      </Disclosure>
                    ))}
                  </form>
                </div>
                {/* Product grid */}
                <div className="lg:col-span-3 md:overflow-auto md:h-[77vh]">
                  {children}
                </div>
              </div>
            </section>
          </main>
        </div>
      </div>
    </>
  );
}
